import apiClient from './apiClient';
import type { MediaFile, UpdateMediaFileDto } from '../types/types';

const mediaFilesService = {
    getAll: async (): Promise<MediaFile[]> => {
        const res = await apiClient.get<MediaFile[]>('/media-files');
        return res.data;
    },

    getById: async (id: number): Promise<MediaFile> => {
        const res = await apiClient.get<MediaFile>(`/media-files/${id}`);
        return res.data;
    },

    create: async (name: string, file: File): Promise<MediaFile> => {
        const formData = new FormData();
        formData.append('name', name);
        formData.append('file', file);
        const res = await apiClient.post<MediaFile>('/media-files', formData, {
            headers: { 'Content-Type': undefined },
        });
        return res.data;
    },

    update: async (id: number, dto: UpdateMediaFileDto): Promise<MediaFile> => {
        const res = await apiClient.patch<MediaFile>(`/media-files/${id}`, dto);
        return res.data;
    },

    remove: async (id: number): Promise<{ message: string }> => {
        const res = await apiClient.delete<{ message: string }>(`/media-files/${id}`);
        return res.data;
    },

    getFileUrl: (id: number): string => {
        const base = apiClient.defaults.baseURL ?? '';
        return `${base}/media-files/${id}/file`;
    },

    resolveFileUrl: (mediaFileId?: number | null, iconSvg?: string | null): string | null => {
        if (mediaFileId != null) return mediaFilesService.getFileUrl(mediaFileId);
        if (!iconSvg?.trim()) return null;
        const v = iconSvg.trim();
        if (v.startsWith('/media-files/') || v.startsWith('/svg-images/')) {
            const base = apiClient.defaults.baseURL ?? '';
            return `${base}${v}`;
        }
        return null;
    },
};

export default mediaFilesService;
